import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import KendoDataSourceMixin from './KendoDataSourceMixin'

export default {
    name: 'kendo-datasource',
    mixins: [ KendoDataSourceMixin ],
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSource/index.js